import { render, staticRenderFns } from "./CategoryInputs.vue?vue&type=template&id=7c2f87cc&"
import script from "./CategoryInputs.vue?vue&type=script&lang=ts&"
export * from "./CategoryInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports